// src/components/quality/Dynamics/DynamicsServicesAssessmentsTable.js

const DynamicsServicesAssessmentsTable = ({ assessments, periodType }) => {


  return (
    <div className="table-container">
      <h3>Оценки по сервисам</h3>

    </div>
  );
};

export default DynamicsServicesAssessmentsTable;
